<template>
    <div class="rf-empty" role="status"><RefreshIcon :name="icon"/><strong>{{ title || $t('lang.NoData') }}</strong><p v-if="description">{{ description }}</p></div>
</template>
<script>
import RefreshIcon from './RefreshIcon.vue'
export default { name: 'RefreshEmpty', components: { RefreshIcon }, props: { title: String, description: String, icon: { type: String, default: 'calendar' } } }
</script>
<style scoped>
.rf-empty { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 14px; min-height: 220px; padding: 36px 20px; color: #b7b8c9; text-align: center; font: 14px/1.6 Inter, 'Segoe UI', Arial, sans-serif; }
.rf-empty > .rf-icon { width: 44px; height: 44px; color: #9293aa; margin-bottom: 4px; }
.rf-empty strong { color: #e7e7ee; font-weight: 500; }
.rf-empty p { max-width: 480px; margin: 0; }
</style>
